import { useQuery, useQueryClient } from '@tanstack/react-query';

import { callGetAdminCompetition } from '@app/client/resources/admin/fantasy/competitions';
import { COMPETITIONS_CACHE } from '@app/client/resources/competitions';

import { useGameSlug } from '../../../fantasyWishlists';

export const useGetAdminCompetition = (providedSlug?: string) => {
    const queryClient = useQueryClient();
    const paramSlug = useGameSlug();
    const gameSlug = providedSlug || paramSlug;
    const cache = [COMPETITIONS_CACHE, gameSlug];

    const hasQueryData = cache && queryClient.getQueryData(cache);
    const disabled = Boolean(hasQueryData || !gameSlug.length);
    const { data, ...rest } = useQuery(
        cache,
        ({ signal }) => callGetAdminCompetition({ slug: gameSlug, settings: { signal } }),
        {
            enabled: !disabled,
            keepPreviousData: true,
            retry: false,
            select: (data) => {
                if (data?.ok && data.value) {
                    return data.value;
                }
            },
        },
    );

    return { gameData: data, ...rest };
};
